export default async function delay(delayInMs: number = 500) {
  return new Promise(resolve => {
    setTimeout(() => {
      // @ts-ignore
      resolve();
    }, delayInMs);
  });
}
